<template>
    <el-menu
        :collapse="collapse" 
        :default-active="activeRoute.id"
        class="menu-container">
        <template v-for="item in realMenuList">
            <el-menu-item v-if="item.route"
                @click="go(item)"
                class="menu-item"
                :route="item.route"
                :index="item.id"
                :key="item.id">
                <i :class="['iconfont center-icon', imgSrc(item)]"/>
                <template #title>{{ item.title }}</template>
            </el-menu-item>
            
            <el-sub-menu v-else
                class="sub-menu"
                :index="item.id"
                :key="item.id + 1">

                <template #title>
                    <i :class="['iconfont center-icon', imgSrc(item)]"/>
                    <span>{{ item.title }}</span>
                </template>
              
                <el-menu-item v-for="subItem in (item.children || [])" 
                    @click="go(subItem)"
                    class="menu-item"
                    :index="subItem.id"
                    :route="subItem.route"
                    :key="subItem.id">
                    <template #title>
                        <div class="sub-menu-title">
                            <span class="circle"></span>
                            <span>{{ subItem.title.substring(0, 10) }}</span>
                        </div>
                    </template>
                </el-menu-item>
            </el-sub-menu>
        </template>
    </el-menu>
</template>

<script setup>
import { computed, onMounted, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import menuData from './menu';
import { deepCopy } from '@/lib/tools.js'
import { staticRoutes } from '@/router';
import { pageJump } from '@/global/location-transfer';

const moocComName = inject('moocComName');

const store = useStore();
const route = useRoute();

const props = defineProps({
    collapse: Boolean
})

const showAI = computed(() => { // 是否显示AI学伴
    let pagePermission = store.state?.pagePermission || {};
    let btnPermission = store.state?.user.btnPermission || []
    return !!pagePermission['ai:my'] && btnPermission.includes('siteFront:teacher_assistant');
})

const showGrowing = computed(() => { // 是否显示我的成果
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['growing:my'];
})

const showCollect = computed(() => { // 是否显示我的收藏
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['collect:my'];
})

// 是否显示AI成长伙伴
const showAIbuddy = computed(() => { 
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['aiBuddy'];
})

// 是否显示我的进阶
const showGrowingAdvance = computed(() => { 
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['aiBuddy:my:advance'];
})

// 是否显示我的成长档案
const showGrowingProfile = computed(() => { 
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['aiBuddy:my:profile'];
})

// 是否显示智能推送
const showMyPush = computed(() => { 
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['aiBuddy:my:push'];
})

// 是否显示我的AI成长伙伴-我的成果
const showMyAchievement = computed(() => { 
    let pagePermission = store.state?.pagePermission || {};
    return !!pagePermission['aiBuddy:my:achivement'];
})

// 全部备案信息
const publishBrand = computed(() => {
    return store.state.brand?.publishBrand || {};
});

// const scoreMode = computed(() => {
//   return store.state?.common?.scoreMode || 0;
// }) // 计分模式（1学分制，2学时制）

/**
 * @type {Array<{id: string}>} realMenuList
 */
const realMenuList = computed(() => {
    if (isOtherUser.value) {
        return menuList.value.filter(item => {
            if (item.isOther) {
                item.route.query = { uId: route.query?.uId };
                return true;
            }
            return false;
        });
    }

    menuList.value.forEach((item, index) => {
        if(item.id == 30) { // 我的学伴根据配置来
            item.hidden = false
            if(!showAI.value) {
                item.hidden = true;
            }
        }
        if(item.id == 6) { // AI成长伙伴根据配置来
            item.hidden = false
            if(!showAIbuddy.value) {
                item.hidden = true;
            }
            const { moduleNameAlias, moduleName } = pagePermission.value?.aiBuddy || {}
            item.title = moduleNameAlias || moduleName || 'AI成长伙伴'
            if (publishBrand.value?.brand === 'scqjyxy') { // 上城
                item.title = '小尚伴学'
                item.route.path = '/buddy/custom/home'
            }
        }
        // AI成长伙伴
        // if(item.id == 6) {
        //     if(!showAIbuddy.value) {
        //         item.hidden = true;
        //         return;
        //     } else {
        //         item.title = pagePermission.value?.['aiBuddy']?.moduleName || 'AI成长伙伴'
        //         // item.title = 'AI成长伙伴'
        //         item.children = [];
        //     }

        //     if (showMyAchievement.value) { // 我的成果根据配置来
        //         item.children.push({
        //             id: '61',
        //             parentId: '6',
        //             route: { name: 'myAchievement' },
        //             title: pagePermission.value?.['aiBuddy:my:achivement']?.moduleName || '我的成果',
        //             isOther: false,
        //         })
        //     }

        //     if (showGrowingProfile.value) { // 我的成长档案根据配置来
        //         item.children.push({
        //             id: '62',
        //             parentId: '6',
        //             route: { name: 'myArchives' },
        //             title: pagePermission.value?.['aiBuddy:my:profile']?.moduleName || '我的成长档案',
        //             isOther: false,
        //         })
        //     }
        //     if (showGrowingAdvance.value) { // 我的进阶根据配置来
        //         item.children.push({
        //             id: '63',
        //             parentId: '6',
        //             route: { name: 'myAdvance' },
        //             title: pagePermission.value?.['aiBuddy:my:advance']?.moduleName || '我的进阶',
        //             isOther: false,
        //         })
        //     }
        //     if (showMyPush.value) { // 智能推送根据配置来
        //         item.children.push({
        //             id: '64',
        //             parentId: '6',
        //             route: { name: 'myPush' },
        //             title: pagePermission.value?.['aiBuddy:my:push']?.moduleName || '智能推送',
        //             isOther: false,
        //         })
        //     }
        // }
        // if(!showGrowingAdvance.value && !showGrowingProfile.value && !showMyPush.value  && !showMyAchievement.value && item.id == 6) {
        //     item.hidden = true; // 若AI成长伙伴下无菜单则隐藏
        // }
        if(!showGrowing.value && item.id == 20) { // 我的成果根据配置来
            item.hidden = true;
        }
        if (!showCollect.value && item.id == 21) { // 我的收藏根据配置来
            item.hidden = true;
        }
    })
    
    return menuList.value.filter(item => !item.hidden).map(item => {
        if (item.isOther) {
            item.route.query = {};
        }
        return item;
    });
});

const pagePermission = computed(() => {
    return store.state?.pagePermission || {};
});

// 协作组别名
const comName = computed(() => {
    return pagePermission.value?.coopgroup?.moduleNameAlias || pagePermission.value?.coopgroup?.moduleName || '协作组';
});

let currentUser = computed(() => {
    return store.state.currentUser || {};
})

// 判断是否是他人视角
const isOtherUser = computed(() => {
    return route.query?.uId && currentUser.value?.userId !== route.query?.uId;
})

// 模板 1是通用模板，需要隐藏我的成果， 2是西城模板
const fromTemplateId = computed(() => {
    return store.state.user?.fromTemplateId || '';
})

// 高亮路由
const activeRoute = computed(() => {
    let curRouteMap = fmtRouter(realMenuList.value) || {};
    if(route.name === 'addAchievement' || route.name === 'detailAchievement') {
        let tempRoute = {
            iconClass: 'menu-fllow-icon',
            id: '20',
            parentId: '0',
            route: { name: 'achievement' },
            title: '我的成果',
            isOther: false
        }
        return tempRoute
    } else if (route.name === 'myScientificResearchCenter') {
        return {
            ...curRouteMap[route.name],
            id: route.params.projectTypeId
        }
    } else {
        return curRouteMap[route.name] || {};
    }
})



// 递归遍历
function fmtRouter (list = [], menuMap = {}) {
    if(list.length) {
        list.forEach(item => {
            if(item.route && item.route.name){
                menuMap[item.route?.name] = item;
            }
            if(item.children && item.children.length) {
                 fmtRouter(item.children, menuMap);
            }
        })
    }
    return menuMap;
}


function imgSrc(item) {
    let cur = (activeRoute.value && activeRoute.value.id === item.id) || (activeRoute.value && activeRoute.value.parentId === item.id);
    return cur ? `${item.iconClass}-active` : item.iconClass;
}

// 用户是否有赛事权限
const hasMyCompetition = computed(() => {
    let keys = store.state.user.btnPermission
    return keys.includes('siteFront:application:myCompetition')
})

let myScCenterMap = {
    'subject': 'myScientificResearch',
    'base_school': 'myBasicSchool',
    'studio': 'myExpertStudio',
    'achievement': 'myResultCultivation',
    'achievement_award': 'myResultSelection',
}

// 获取应用
async function getApplicationList() {
    G_transmit('getUserCenterLatestBrand', {
       name: 'getUserCenterLatestBrand'
    }).then(async res => {
        const result = await G_transmit('escHomeGetProjectType', {});
        const data = res?.data || [];
        let tempMap = {};
        let subMenuList = data.filter(item => {
            if(item.moduleKey && staticRoutes[item.moduleKey] && staticRoutes[item.moduleKey].name){
                if(!tempMap[item.moduleKey]){
                    tempMap[item.moduleKey] = item;
                    return true;
                }
            }
            return false;
        });
        subMenuList = subMenuList.length && subMenuList.map(item => {
                let title = staticRoutes[item.moduleKey].title;
                if (item.moduleKey === 'coopgroup:my') {
                    title = `我的${comName.value}`;
                } else if (item.moduleKey === 'moocApplication:my') {
                    title = `我的${moocComName}`;
                } else if (item.moduleKey === 'project:my') {
                    title = '我的课题';
                }
                return {
                    id: item.moduleKey,
                    parentId: '2',
                    title: title,
                    route: {name: staticRoutes[item.moduleKey].name},
                    isOther: false
                }
        }) || [];
        (result?.data || []).forEach(item => {
            subMenuList.push({
                id: item.id,
                parentId: '2',
                title: item.name, // myScCenterMap[item.code]
                // route: {path: '/idx/userCenter/scientificResearchCenter/' + item.code + '/' + item.id},
                route: {name: 'myScientificResearchCenter', params: {projectType: item.code, projectTypeId: item.id}},
                isOther: false
            })
        })
        /* if(hasMyCompetition.value){
            subMenuList.push({
                id: 'fruitApplication:my',
                parentId: '2',
                title: '我的赛事',
                route: { name: 'myfruit' },
                isOther: false
            })
        } */
        let index = menuList.value.findIndex(item => item.id == 2);
        if(index) {
            menuList.value[index].children = subMenuList ?? [];
        }
    }).catch(() => {

    });
}

// 获取我的应用不调用科研接口
function getApplicationWithoutSc() {
    G_transmit('getUserCenterLatestBrand', {
       name: 'getUserCenterLatestBrand'
    }).then(res => {
        const data = res?.data || [];
        let tempMap = {};
        let subMenuList = data.filter(item => {
            if(item.moduleKey && staticRoutes[item.moduleKey] && staticRoutes[item.moduleKey].name){
                if(!tempMap[item.moduleKey]){
                    tempMap[item.moduleKey] = item;
                    return true;
                }
            }
            return false;
        });
        subMenuList = subMenuList.length && subMenuList.map(item => {
                let title = staticRoutes[item.moduleKey].title;
                if (item.moduleKey === 'coopgroup:my') {
                    title = `我的${comName.value}`;
                } else if (item.moduleKey === 'moocApplication:my') {
                    title = `我的${moocComName}`;
                } else if (item.moduleKey === 'project:my') {
                    title = '我的课题';
                }
                return {
                    id: item.moduleKey,
                    parentId: '2',
                    title: title,
                    route: {name: staticRoutes[item.moduleKey].name},
                    isOther: false
                }
        }) || [];
        /* if(hasMyCompetition.value){
            subMenuList.push({
                id: 'fruitApplication:my',
                parentId: '2',
                title: '我的赛事',
                route: { name: 'myfruit' },
                isOther: false
            })
        } */
        let index = menuList.value.findIndex(item => item.id == 2);
        if(index) {
            menuList.value[index].children = subMenuList ?? [];
        }
    }).catch(() => {

    });
}



const menuList = ref([]);

function go(item) {
   if(item.route?.name) {
       pageJump(item.route);
   }else {
       pageJump(item.route?.path, true);
   }
}

onMounted(() => {    
    menuList.value = deepCopy(menuData);
    if (process.env.VUE_APP_SCENE == 'xcjyyxw') {
        getApplicationWithoutSc();
    } else {
        getApplicationList();
    }      
})


</script>

<style lang="scss" scoped>
.menu-container {
    width: 200px;
    height: 100%;
    background: var(--srt-color-white);
    border-radius: 4px;
    padding: 20px 6px;
    box-sizing: border-box;
    border: none;
    font-size: 16px;
    :deep(.el-menu-item){
        height: 38px;
        width: 100%;
        min-width: 0;
        margin-bottom: 22px;
        border-radius: 4px;
        font-size: 16px;
        color: #222222;
        line-height: normal;
        &:hover{
            background: #f7f9fA;
        }
    }
    :deep(.el-menu-item.is-active){
        background: var(--srt-color-blue-auxiliary1);
        font-weight: bold;
        color: var(--srt-main-active-text-color);
        .circle{
            background-color: var(--srt-main-active-text-color);
        }
        .center-icon {
            color: var(--srt-main-active-text-color);
        }
    }
    :deep(.el-sub-menu){
        margin-bottom: 22px;
        // font-size: 14px;
        & .is-active{
            background: #E7F1FF;
            color: var(--srt-main-active-text-color);
        }
        .el-menu-item{
            font-size: 14px;
            font-weight: normal;
            margin-bottom: 6px;
        }
    }
    &>li:last-child{
        margin-bottom: 0;
    }
    :deep(.el-sub-menu__title){
        border-radius: 4px;
        height: 38px;
        font-size: 16px;
        margin-bottom: 8px;
        &:hover{
            background: none;
            .el-sub-menu__icon-arrow {
                color: var(--srt-main-active-text-color);
            }
        }
    }
    .is-opened.is-active{
        .el-sub-menu__title{
            font-weight: bold;
            color: var(--srt-main-active-text-color);
        }
        i{
            color: var(--srt-color-light-gray);
        }
        .center-icon {
            color: var(--srt-main-active-text-color);
        }
    }
    .img-icon{
        width:18px;
        height: 18px;
        margin-right: 8px;
    }
    ::deep(.sub-menu-title){
        display: flex;
        align-items: center;
        padding-left: 6px;
        .circle{
            display: inline-block;
            width:4px;
            height: 4px;
            background-color: var(--srt-color-light-gray);
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    :deep(.el-sub-menu__icon-arrow){
        right:14px;
    }
    .center-icon {
        font-size: 18px;
        color: var(--srt-color-light-gray);
        font-style: normal;
        margin-right: 8px;
        font-weight: normal;
    }
    .menu-home-icon {
        &:before {
            content: '\e6b5';
            font-family: 'iconfont';
        }
    }
    .menu-home-icon-active {
        &:before {
            content: '\e68d';
            font-family: 'iconfont';
        }
    }
    .menu-app-icon {
        &:before {
            content: '\e6b6';
            font-family: 'iconfont';
        }
    }
    .menu-app-icon-active {
        &:before {
            content: '\e68a';
            font-family: 'iconfont';
        }
    }
    .menu-archive-icon {
        &:before {
            content: '\e6c4';
            font-family: 'iconfont';
        }
    }
    .menu-archive-icon-active {
        &:before {
            content: '\e6c5';
            font-family: 'iconfont';
        }
    }
    .menu-collect-icon {
        &:before {
            content: '\e686';
            font-family: 'iconfont';
        }
    }
    .menu-collect-icon-active {
        &:before {
            content: '\e6bc';
            font-family: 'iconfont';
        }
    }
    .menu-fllow-icon {
        font-size: 16px;
        &:before {
            content: '\e6b8';
            font-family: 'iconfont';
        }
    }
    .menu-fllow-icon-active {
        font-size: 16px;
        &:before {
            content: '\e68b';
            font-family: 'iconfont';
        }
    }
    .menu-accout-icon {
        &:before {
            content: '\e6b7';
            font-family: 'iconfont';
        }
    }
    .menu-accout-icon-active {
        &:before {
            content: '\e68c';
            font-family: 'iconfont';
        }
    }
    .menu-message-icon {
        font-size: 16px;
        &:before {
            content: '\e6c3';
            font-family: 'iconfont';
        }
    }
    .menu-message-icon-active {
        font-size: 16px;
        &:before {
            content: '\e6c2';
            font-family: 'iconfont';
        }
    }
    .menu-dashboard-icon {
        font-size: 16px;
        &:before {
            content: '\e64a';
            font-family: 'iconfont';
        }
    }
    .menu-dashboard-icon-active {
        font-size: 16px;
        &:before {
            content: '\e649';
            font-family: 'iconfont';
        }
    }
    .menu-buddy-icon {
        font-size: 18px;
        &:before {
            content: '\e717';
            font-family: 'iconfont';
        }
    }
    .menu-buddy-icon-active {
        font-size: 18px;
        &:before {
            content: '\e717';
            font-family: 'iconfont';
        }
    }

    .menu-feedback-icon {
        font-size: 18px;
        &:before {
            content: '\e61e';
            font-family: 'iconfont';
        }
    }
    .menu-feedback-icon-active {
        font-size: 18px;
        &:before {
            content: '\e61f';
            font-family: 'iconfont';
        }
    }

    // 我的进阶
    .menu-advance-icon {
        &:before {
            content: '\e663';
            font-family: 'iconfont';
        }
    }
    .menu-advance-icon-active {
        &:before {
            content: '\e660';
            font-family: 'iconfont';
        }
    }

    // 我的成长档案
    .menu-archives-icon {
        &:before {
            content: '\e65f';
            font-family: 'iconfont';
        }
    }
    .menu-archives-icon-active {
        &:before {
            content: '\e65e';
            font-family: 'iconfont';
        }
    }

}
</style>
